class Cloner {
    clone(object) {
        return JSON.parse(JSON.stringify(object));
    }
}

const cloner = new Cloner();
export default cloner;